import { api } from './api'
import { NoteSectionType } from './autocompleteService'

export interface CustomPhrase {
  id: string
  userId: string
  text: string
  trigger: string
  sectionType?: NoteSectionType
  category?: string
  usageCount?: number
  createdAt: string
  updatedAt: string
}

export interface CreateCustomPhraseRequest {
  text: string
  trigger?: string
  sectionType?: NoteSectionType
  category?: string
}

export interface UpdateCustomPhraseRequest {
  text?: string
  trigger?: string
  sectionType?: NoteSectionType
  incrementUsage?: boolean
}

export const customPhraseService = {
  /**
   * Get all custom phrases for the current user
   */
  getAll: async (sectionType?: NoteSectionType): Promise<CustomPhrase[]> => {
    const params = sectionType ? { sectionType } : undefined
    const response = await api.get<CustomPhrase[]>('/custom-phrases', { params })
    return response.data
  },

  /**
   * Get a single custom phrase by ID
   */
  getById: async (id: string): Promise<CustomPhrase> => {
    const response = await api.get<CustomPhrase>(`/custom-phrases/${id}`)
    return response.data
  },

  /**
   * Create a new custom phrase
   */
  create: async (data: CreateCustomPhraseRequest): Promise<CustomPhrase> => {
    const response = await api.post<CustomPhrase>('/custom-phrases', data)
    return response.data
  },

  /**
   * Update a custom phrase
   */
  update: async (id: string, data: UpdateCustomPhraseRequest): Promise<CustomPhrase> => {
    const response = await api.put<CustomPhrase>(`/custom-phrases/${id}`, data)
    return response.data
  },

  /**
   * Delete a custom phrase
   */
  delete: async (id: string): Promise<void> => {
    await api.delete(`/custom-phrases/${id}`)
  },

  /**
   * Increment usage count for a phrase (when it's used)
   */
  incrementUsage: async (id: string): Promise<CustomPhrase> => {
    return customPhraseService.update(id, { incrementUsage: true })
  },
}
